// extracted by mini-css-extract-plugin
export default {"list":"FkVCG3","button":"ultkje","buttonStateActive":"mIt_Wa","label":"alUIir"};